import React from 'react'
import Image from "next/legacy/image"
import styled from 'styled-components'
import tick from '../icons/svg/union/tick.svg'
import cross from '../icons/svg/union/cross.svg'
import { ImageDiv, ContentText } from './LoginScreen/elements'

const CardDetail = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0.5rem 0;
`

const CardImage = styled(Image).attrs(props => ({
  src: props.src,
  objectfit: 'contain',
  layout: 'fill',
  loading: 'eager',
}))``

const CardText = styled.div`
  &:before {
    content: url(${props => (props.eligible ? tick : cross)});
    margin-right: 0.3rem;
  }
`

const CardsWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
`

const FootnotesWrapper = styled.div`
  margin: 1rem 0;
`

const CardsDetails = ({ title, details, footnotes = [] }) => {
  return (
    <>
      <ContentText bold extramargin>
        {title}
      </ContentText>
      <CardsWrapper>
        {details.map((card, i) => (
          <CardDetail key={i}>
            <ImageDiv>
              <CardImage src={card.src} />
            </ImageDiv>
            <CardText eligible={card.eligible}>{card.text}</CardText>
          </CardDetail>
        ))}
        {footnotes.length > 0 && (
          <FootnotesWrapper>
            {footnotes.map((footnote, i) => (
              <ContentText footnote key={i}>
                {footnote}
              </ContentText>
            ))}
          </FootnotesWrapper>
        )}
      </CardsWrapper>
    </>
  )
}

export default CardsDetails
